import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { SearchResults } from './SearchResults';
import styles from './Search.module.css'
import { searchActions } from '_actions';

class Search extends React.Component {

    renderResultCountMessage() {
        var word = 'Result';
        word = this.props.totalResults > 1 ? word += 's' : word;
        return <div className={styles.result_count}><i>{this.props.totalResults} {word} Found</i></div>
    }

    callQuickSearch(searchStr) {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
            this.props.search(searchStr, 1)
        }, 5000);
    }

    renderSearchResults() {
        if (this.props.searchStr.length < 3) {
            return (<div></div>)
        } else if (this.props.results && Object.keys(this.props.results).length > 0) {
            return (
                <div>
                    {this.renderResultCountMessage()}
                    <SearchResults />
                </div>
            )
        } else if (this.props.results && Object.keys(this.props.results).length === 0 && this.props.searchStr.length > 2) {
            return (<div className={styles.result_count}><i>No Results</i></div>);
        }
    }

    render() {
        return (
            <div style={{ width: '100%' }}>
                <div className={styles.contents}>
                    <input autoFocus className={styles.input} type="text" placeholder="Search Here" onChange={event => this.callQuickSearch(event.target.value, 1)} />
                    <FontAwesomeIcon className={styles.icon} icon={faSearch} />
                </div>
                {this.renderSearchResults()}
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        searchStr: state.ui.search.searchStr,
        results: state.entities.search,
        totalResults: state.ui.search.totalResults,
        timeout: 0
    };
}


function mapDispatchToProps(dispatch) {
    return {
        search: bindActionCreators(searchActions.search, dispatch)
    };
}

const connectedSearch = connect(mapStateToProps, mapDispatchToProps)(Search);
export { connectedSearch as Search };

